module.exports = __webpack_public_path__ + "3f3f35fe6b81d00ff468e012a35f6296.png";